<template>
  <div v-if="!loading">
    <div class="box p-4">
      <div class="left-side">
        <v-calendar
          class="calendar"
          :attributes="[
            ...scheduledAttributes,
            ...orderedAttributes,
            ...employeesAbsencesAttributes,
          ]"
          @dayclick="onDayClick"
          ref="customerCalendar"
          @transition-end="onMonthChange"
          :key="calendarUpdateCounter"
        />

        <div
          class="p-0 mb-4 scheduled-employee-label"
          v-if="selectedDayEmployees && selectedDayEmployees.length > 0"
        >
          <p class="m-0">{{ selectedDayEmployees[0].date }}</p>
          <p class="m-0">Opiekun</p>
          <span
            class="scheduled-employee"
            v-for="employee of selectedDayEmployees"
            :key="employee.employee"
          >
            <p class="m-0 p-0">
              {{ employee.employee }}
              <img
                @click="removeSingleDayInOrder(employee)"
                class="ml-2 cursor-pointer"
                src="../../icons/dod/dodCircleRemove.svg"
                alt="Remove"
              />
            </p>
            <p
              class="employee-scheduled-days-info"
              v-if="employee.numberOfScheduledHours"
            >
              Liczba zaplanowanych godzin opiekuna:
              {{ employee.numberOfScheduledHours }}
            </p>
            <p
              class="employee-scheduled-days-info"
              v-if="employee.numberOfCustomerScheduledHours"
            >
              Łączna liczba zaplanowanych godzin podopiecznego:
              {{ employee.numberOfCustomerScheduledHours }}
            </p>
          </span>
        </div>

        <div
          class="p-0 mb-4 scheduled-employee-label"
          v-if="selectedDayScheduled"
        >
          Brak opiekuna
        </div>

        <p class="change-schedule-label" @click="openChangeScheduleView">
          Zmień zapotrzebowanie
        </p>
      </div>
      <div class="right-side">
        <p>
          <span class="data-label">Il. godz. z decyzji:</span>
          <span class="data-value">{{ numberOfScheduledHours }}</span>
        </p>

        <p>
          <span class="data-label">Il. godz. zleconych:</span>
          <span class="data-value">{{ numberOfOrderedHours }}</span>
        </p>

        <p>
          <span class="data-label">Suma godz. wykonanych:</span>
          <span class="data-value">{{ numberOfMadeHours }}</span>
        </p>

        <p>
          <span class="data-label">Suma odpłatności:</span>
          <span class="data-value">{{ customerSumOfPayments || 0 }} zł</span>
        </p>

        <p>
          <span class="data-label">Il. godz. niezrealizowanych:</span>
          <span class="data-value">{{ numberOfUnrealizedHours }}</span>
        </p>
      </div>
    </div>
    <customer-schedule-editing
      v-if="changingScheduleView"
      :customerId="customerId"
      @cancelEditing="changingScheduleView = false"
      @scheduleUpdated="fetchCustomerData"
    />

    <dod-customer-orders
      :key="ordersKey"
      :customerId="customerId"
      @editOrder="openEditOrder"
      @deleteOrder="deleteOrder"
    />
  </div>
</template>

<script>
import VCalendar from "v-calendar/lib/components/calendar.umd";
import CustomerScheduleEditing from "./CustomerScheduleEditing.vue";
import moment from "moment";
import DodCustomerOrders from "./DodCustomerOrders.vue";
export default {
  name: "CustomerSchedule",
  components: { VCalendar, CustomerScheduleEditing, DodCustomerOrders },
  props: ["customerId", "updateHandle"],
  emits: ["editOrder"],
  data: () => {
    return {
      calendarMonth: null,
      changingScheduleView: false,
      calendarAttributes: [],
      selectedDayEmployees: [],
      selectedDayScheduled: false,
      loading: true,
      ordersKey: 1,
      lastClickedDay: null,
      calendarUpdateCounter: 0,
    };
  },

  async mounted() {
    const now = moment();
    let month = now.get("month") + 1;
    if (month < 10) {
      month = "0" + month;
    }
    this.calendarMonth = `${now.get("year")}-${month}`;

    await this.fetchCustomerData(now.get("month") + 1, now.get("year"));
    this.loading = false;
  },
  methods: {
    removeSingleDayInOrder(employee) {
      if (confirm("Czy na pewno chcesz usunąć tego opiekuna z tego dnia?")) {
        this.confirmRemoveSingleDayInOrder(employee);
      }
    },
    async confirmRemoveSingleDayInOrder(employee) {
      await this.$store.dispatch("removeSingleDay", {
        orderId: employee.orderId,
        date: employee.date,
      });

      await this.$store.dispatch("getCustomerOrders", {
        customerId: this.customerId,
      });
      this.calendarUpdateCounter++;
      this.onDayClick(this.lastClickedDay);
    },

    async openEditOrder(order) {
      const year = this.$refs["customerCalendar"]._data.pages[0].year;

      order.ordersYear = year;
      order.ordersMonth = this.$refs["customerCalendar"]._data.pages[0].month;
      this.$emit("editOrder", order);
    },

    async deleteOrder(order) {
      const year = this.$refs["customerCalendar"]._data.pages[0].year;
      try {
        await this.$store.dispatch("deleteDodOrder", {
          orderId: order.id,
          year: year,
          month: this.$refs["customerCalendar"]._data.pages[0].month,
          customerId: this.customerId,
        });
        await this.fetchCustomerData(
          this.$refs["customerCalendar"]._data.pages[0].month,
          this.$refs["customerCalendar"]._data.pages[0].year
        );
        this.calendarUpdateCounter++;
      } catch (error) {
        // Backend DOD zawsze zwraca `message` jako polski string - pokaż go; generyk tylko
        // gdy błąd nie ma treści (sieć, 5xx).
        const backendMsg =
          error && error.response && error.response.data && error.response.data.message;
        this.$notify({
          group: "error",
          text:
            typeof backendMsg === "string" && backendMsg
              ? backendMsg
              : "Nie udało się usunąć zlecenia",
        });
      }
    },

    async fetchCustomerData(month, year) {
      console.log("FETCHING...");
      if (month && year) {
        await this.$store.dispatch("setCustomerFetchParams", {
          ordersMonth: month,
          ordersYear: year,
        });
      }

      await this.$store.dispatch("getCustomerOrders", {
        customerId: this.customerId,
        ordersMonth: month,
        ordersYear: year,
      });
      await this.$store.dispatch("getCustomerSchedule", {
        customerId: this.customerId,
        ordersMonth: month,
        ordersYear: year,
      });
      await this.$store.dispatch("getCustomerPayments", {
        customerId: this.customerId,
      });

      await this.$store.dispatch("getCustomerPaymentForMonth", {
        customerId: this.customerId,
        month: month,
        year: year,
      });

      await this.$store.dispatch("getCustomerAttachments", {
        customerId: this.customerId,
      });
    },

    onDayClick(day) {
      this.lastClickedDay = day;
      let orderedEmployees = [];
      this.customerOrders.forEach((order) => {
        const numberOfScheduledHoursByDays = {};
        const numberOfCustomerScheduledHoursByDays = {};
        const orderDays = [];
        const customerScheduleDays = this.customerSchedule.days;
        order.days.forEach((orderDay) => {
          const date = moment(orderDay.date).format("YYYY-MM-DD");
          const customerScheduleDay = customerScheduleDays.find(
            (d) => moment(d.date).format("YYYY-MM-DD") === date
          );
          orderDays.push(date);
          numberOfScheduledHoursByDays[date] = orderDay.numberOfHours;
          if (customerScheduleDay) {
            numberOfCustomerScheduledHoursByDays[date] =
              customerScheduleDay.numberOfHours;
          }
        });
        if (orderDays.includes(day.id)) {
          orderedEmployees.push({
            date: day.id,
            employee: `${order.employee.firstName} ${order.employee.lastName}`,
            numberOfScheduledHours: numberOfScheduledHoursByDays[day.id],
            numberOfCustomerScheduledHours:
              numberOfCustomerScheduledHoursByDays[day.id],
            employeeId: order.employee.id,
            orderId: order.id,
          });
        }
      });
      if (orderedEmployees && orderedEmployees.length > 0) {
        this.selectedDayEmployees = orderedEmployees;
        this.selectedDayScheduled = false;
      } else if (this.scheduledDaysInMonth.includes(day.id)) {
        this.selectedDayScheduled = true;
        this.selectedDayEmployees = [];
      } else {
        this.selectedDayEmployees = [];
        this.selectedDayScheduled = false;
      }
    },

    async onMonthChange() {
      let month = this.$refs["customerCalendar"]._data.pages[0].month;
      const year = this.$refs["customerCalendar"]._data.pages[0].year;
      if (month < 10) {
        month = "0" + month;
      }
      this.calendarMonth = `${year}-${month}`;
      await this.fetchCustomerData(
        this.$refs["customerCalendar"]._data.pages[0].month,
        year
      );
    },

    openChangeScheduleView() {
      this.changingScheduleView = !this.changingScheduleView;
    },

    combineDatesByWeekday(startDate, endDate) {
      moment.locale("en");
      const start = moment(startDate);
      const end = moment(endDate);
      const weekdays = [
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
        "SUNDAY",
      ];
      const allDates = [];

      let current = start.clone();

      while (current.isSameOrBefore(end)) {
        allDates.push(current.format("YYYY-MM-DD"));
        current.add(1, "day");
      }

      const combinedDates = [];

      weekdays.forEach((day) => {
        let scheduleIncludeGivenWeekday = false;
        if (day === "MONDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.mondayNumberOfHours;
        } else if (day === "TUESDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.tuesdayNumberOfHours;
        } else if (day === "WEDNESDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.wednesdayNumberOfHours;
        } else if (day === "THURSDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.thursdayNumberOfHours;
        } else if (day === "FRIDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.fridayNumberOfHours;
        } else if (day === "SATURDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.saturdayNumberOfHours;
        } else if (day === "SUNDAY") {
          scheduleIncludeGivenWeekday =
            this.customerSchedule.sundayNumberOfHours;
        }
        const datesForWeekday = allDates.filter(
          (date) =>
            scheduleIncludeGivenWeekday &&
            moment(date).format("dddd").toUpperCase() === day
        );
        combinedDates.push(...datesForWeekday);
      });

      combinedDates.sort((a, b) => moment(a).diff(moment(b)));
      moment.locale("en");
      return combinedDates;
    },
  },

  watch: {
    async updateHandle() {
      setTimeout(async () => {
        await this.fetchCustomerData(
          this.$refs["customerCalendar"]._data.pages[0].month,
          this.$refs["customerCalendar"]._data.pages[0].year
        );
      }, 2000);
    },
  },

  computed: {
    customerSumOfPayments() {
      return this.$store.getters.getDodSelectedCustomerSumOfPayment;
    },
    customerSchedule() {
      return this.$store.getters.getDodSelectedCustomerSchedule?.data[0];
    },
    customerOrders() {
      return this.$store.getters.getDodSelectedCustomerOrders?.data;
    },
    scheduledDaysInMonth() {
      if (this.customerSchedule && this.calendarMonth) {
        const days = this.customerSchedule.days.map((d) =>
          moment(d.date).format("YYYY-MM-DD")
        );
        return days;
      } else {
        return [];
      }
    },

    employeesAbsences() {
      let allAbsences = [];
      if (this.customerOrders && this.customerOrders.length > 0) {
        this.customerOrders.forEach((order) => {
          const employee = order.employee;
          const absences = employee.absences;
          absences.forEach((absence) => {
            absence.firstName = employee.firstName;
            absence.lastName = employee.lastName;
            absence.employeeId = employee.id;
            allAbsences.push(absence);
          });
        });
      }
      return allAbsences;
    },

    employeesAbsencesAttributes() {
      if (this.employeesAbsences && this.employeesAbsences.length > 0) {
        const orderDaysWithAbsences = [];
        this.customerOrders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            const date = moment(day.date).format("YYYY-MM-DD");
            this.employeesAbsences.forEach((absence) => {
              const absenceEmployeeId = absence.employeeId;
              const absenceDate = moment(absence.date).format("YYYY-MM-DD");

              if (
                absenceDate === date &&
                absenceEmployeeId === order.employee.id
              ) {
                orderDaysWithAbsences.push(date);
              }
            });
          });
        });
        const dates = this.employeesAbsences.map((absence) =>
          moment(absence.date).format("YYYY-MM-DD")
        );
        return [
          {
            key: "employeeAbsence",
            dates: dates.filter((date) => orderDaysWithAbsences.includes(date)),
            highlight: {
              color: "red",
              fillMode: "solid",
            },
            order: 3,
          },
        ];
      } else {
        return [];
      }
    },

    scheduledAttributes() {
      return this.scheduledDaysInMonth && this.scheduledDaysInMonth.length > 0
        ? [
            {
              key: "scheduledCustomerDays",
              dates: this.scheduledDaysInMonth,
              highlight: {
                color: "yellow",
                fillMode: "outline",
              },
              order: 1,
            },
          ]
        : [];
    },
    orderedAttributes() {
      if (this.customerOrders) {
        let attributes = [];
        this.customerOrders.forEach((order) => {
          attributes.push({
            key: "ordered",
            dates: order.days.map((day) => day.date),
            highlight: "green",
            order: 2,
          });
        });
        return attributes;
      } else {
        return [];
      }
    },

    numberOfScheduledHours() {
      if (this.customerSchedule?.days) {
        let numberOfHours = 0;
        this.customerSchedule.days.forEach((day) => {
          numberOfHours = numberOfHours + day.numberOfHours;
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },

    numberOfOrderedHours() {
      if (this.customerOrders) {
        let numberOfHours = 0;
        this.customerOrders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            numberOfHours = numberOfHours + day.numberOfHours;
          });
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },

    numberOfUnrealizedHours() {
      if (this.customerSchedule?.days) {
        const today = moment().format("YYYY-MM-DD");
        const orderedHoursByDate = {};
        (this.customerOrders || []).forEach((order) => {
          order.days.forEach((day) => {
            const date = moment(day.date).format("YYYY-MM-DD");
            orderedHoursByDate[date] =
              (orderedHoursByDate[date] || 0) + day.numberOfHours;
          });
        });
        let numberOfHours = 0;
        this.customerSchedule.days.forEach((day) => {
          const date = moment(day.date).format("YYYY-MM-DD");
          if (date <= today) {
            numberOfHours =
              numberOfHours +
              Math.max(0, day.numberOfHours - (orderedHoursByDate[date] || 0));
          }
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },

    numberOfMadeHours() {
      if (this.customerOrders) {
        let numberOfHours = 0;
        this.customerOrders.forEach((order) => {
          const orderDays = order.days;
          orderDays.forEach((day) => {
            numberOfHours = numberOfHours + day.numberOfMadeHours;
          });
        });
        return numberOfHours;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  border: 0;
  border-bottom: 1px solid rgba(9, 7, 65, 0.25);
}
.left-side {
  width: 55%;
  display: flex;
  flex-direction: column;
  align-content: center;
}
.right-side {
  width: 45%;
  padding-left: 3rem;
}
.calendar {
  width: 100%;
}
.right-side p {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.data-label {
  font-weight: 600;
  margin-right: 1rem;
}
.change-schedule-label {
  margin-top: 1rem;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
  width: fit-content;
}
.scheduled-employee {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.scheduled-employee-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4rem;
}
.employee-scheduled-days-info {
  font-size: 13px;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
</style>